"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MODALS_WORDINGS = {
    DEFAULT: {
        CTA: {
            OK: 'J\'ai compris !',
            CONFIRM: 'Confirmer',
            CANCEL: 'Annuler',
        },
        TITLE: {
            ERROR: 'Erreur',
            WARNING: 'Attention !',
        }
    },
    UNSUBSCRIBE: {
        ACTIVE_ORDER: {
            CONTENT: 'En vous désabonnant, <b>vos commandes en cours bénéficiant de vos avantages d\'abonné seront automatiquement annulées.</b> Confirmez-vous votre désabonnement&nbsp;?',
            CONFIRM_CTA: 'Confirmer mon désabonnement',
        },
    }
};
exports.default = MODALS_WORDINGS;
//# sourceMappingURL=Modals.js.map